import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    currentUserId: Number
  }

  connect() {
    this.markIncomingMessagesRead()
    this.observer = new MutationObserver((mutations) => this.handleMutations(mutations))
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  }

  handleMutations(mutations) {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) this.markIncomingMessagesRead(node)
      })
    })
  }

  markIncomingMessagesRead(root = this.element) {
    this.messageElements(root).forEach((message) => this.markMessageRead(message))
  }

  messageElements(root) {
    const selector = "[data-read-receipts-read-url]"
    const messages = Array.from(root.querySelectorAll(selector))

    if (root.matches?.(selector)) messages.unshift(root)

    return messages
  }

  markMessageRead(message) {
    if (message.dataset.readReceiptsStatus === "read") return
    if (Number(message.dataset.senderId) === this.currentUserIdValue) return
    if (message.dataset.readReceiptsPending === "true") return

    message.dataset.readReceiptsPending = "true"

    fetch(message.dataset.readReceiptsReadUrl, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": this.csrfToken,
        "Accept": "text/vnd.turbo-stream.html, text/html, application/xhtml+xml"
      },
      credentials: "same-origin"
    }).catch(() => {
      delete message.dataset.readReceiptsPending
    })
  }

  get csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content
  }
}
